import React from "react";
import { useTranslation } from "react-i18next";

const ClinicAdditionModal = ({ open, onClose, onRedirect, isUpdate = false }) => {
  const { t, i18n } = useTranslation();

  if (!open) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.18)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      dir={i18n.dir()}
      lang={i18n.language}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 2px 16px #0002",
          padding: "40px 32px 32px 32px",
          minWidth: 340,
          maxWidth: "90vw",
          textAlign: "center",
          position: "relative",
        }}
      >
        <div style={{ fontSize: 17, color: "#444", marginBottom: 32 }}>
         <h2> {isUpdate ? t("clinicSetup.success.updateMessage") : t("clinicSetup.success.message")}</h2>
        </div>
        <button
          onClick={onClose}
          style={{
            background: "#1dd1a1",
            color: "#fff",
            border: "none",
            borderRadius: 8,
            fontWeight: 600,
            fontSize: 17,
            padding: "12px 32px",
            cursor: "pointer",
            marginBottom: 8,
          }}
        >
          {t("clinicSetup.success.close")}
        </button>
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: 12,
            right: 18,
            background: "none",
            border: "none",
            fontSize: 22,
            color: "#888",
            cursor: "pointer",
          }}
          aria-label={t("clinicSetup.success.close")}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ClinicAdditionModal;
